import { getBackendPath } from 'helpers/Uri';
import { Dispatch } from 'redux';
import { setPromosAction } from 'stores/Promo';
import * as promoModel from 'model/IPromo';
import * as rdHelper from 'helpers/Uri';

export const fetchAndStorePromos = async (
    dispatch: Dispatch
): Promise<void> => {
    //const requestOptions: any = {
    //    method: 'POST',
    //    headers: {
    //        'Content-Type': 'application/json',
    //    },
    //    credentials: 'include',
    //};



    //await new Promise((resolve) => setTimeout(resolve, 200)); //simulate deley

    ////array of all possible promotions. API won't deliver promotions that are inactive
    //const dummyPromos: promoModel.IPromo[] = [
    //    {
    //        name: 'lyriq-eofy-discount-2025',
    //        data: {
    //            amount: 5000, //just an example. any custom data for promotion could go here
    //        },
    //    },
    //];
    //dispatch(setPromosAction(dummyPromos));

    //return; // remove above once api created

    try {
        //const response = await fetch(
        //    `${getBackendPath()}/api/Promo/get-active-promos`, // Update to match backend
        //    requestOptions
        //);

        //const json = await response.json();
        //rdHelper.noActivityRedirectHomePage(json);

        //const promos: promoModel.IPromo[] = json;
        //dispatch(setPromosAction(promos));


        const requestOptions: any = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({}),
            credentials: 'include',
        };
        const response = await fetch(
            `${getBackendPath()}/api/Promo/get-promos`,
            requestOptions,
        );
        const json = await response.json();
        rdHelper.noActivityRedirectHomePage(json);
        //return json;
        const promos: promoModel.IPromo[] = json.data;
        dispatch(setPromosAction(promos));

    } catch (error) {
        console.error('Failed to fetch promos:', error);
    }
};
